import React, { useState, useEffect } from "react";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import Form from "./Form";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import {
  apiEndpoints,
  apiPostRequest,
  apiPutRequest,
  apiGetByIdRequest,
  apiGetRequest,
} from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { checkAllFieldHasValue, addNameFieldForKey } from "src/utils/utils";
import { kmLabels } from "src/constant/Texts";
import KmPageTitle from "src/components/layout/KmPageTitle"

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const Profile = ({
  setLogoutUser,
  enableGlobalLoader,
  disableGlobalLoader,
  ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { entryId } = useParams();
  const [userProfile, setUserProfile] = useState({ name: "" });
  const [permissions, setPermissions] = useState(null);
  const editMode = rest.kmaction === "edit";
  const [areDictsLoaded, setDictsLoaded] = useState(false);

  let pageTitle =
    rest.kmaction === "new"
      ? "Nowy profil"
      : "Edycja profilu";

  let dictsLoadStatus = {
    permissions: false,
  };

  useEffect(() => {
    enableGlobalLoader();
    apiGetRequest(apiEndpoints.getProfilesPermissions.path, true)
      .then((data) => {
        disableGlobalLoader();
        let processedPermissions = addNameFieldForKey(data,kmLabels.user_permissions);

        setPermissions(processedPermissions);
        dictsLoadStatus = { ...dictsLoadStatus, permissions: true };
        setDictsLoaded(checkAllFieldHasValue(dictsLoadStatus, true));
      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response && error.response.status === 401) {
          setLogoutUser();
        } else {
          navigate("/profile");
        }
      });
    if (editMode) {
      enableGlobalLoader();
      apiGetByIdRequest(apiEndpoints.getProfileDetails.path, entryId, true)
        .then((data) => {
          disableGlobalLoader();
          let processedUserPermissions = addNameFieldForKey(data.profilePermissions,kmLabels.user_permissions);
          data.profilePermissions = processedUserPermissions;
          setUserProfile(data);
        })
        .catch((error) => {
          disableGlobalLoader();
        });
    }
    return () => {};
  }, []);

  const onSubmit = (data) => {
    enableGlobalLoader();

    if (editMode) {
      apiPutRequest(
        apiEndpoints.updateProfile.path,
        {
          id: entryId,
          name: data.name,
          permissions: data.permissions.map((permission) => permission.key),
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          navigate("/profile");
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          }
        });
    } else {
      apiPostRequest(
        apiEndpoints.addProfile.path,
        {
          name: data.name,
          permissions: data.permissions.map((permission) => permission.key),
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          navigate("/profile");
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          }
        });
    }
  };

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>
        {pageTitle}
      </KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          <Form
            onSubmit={onSubmit}
            permissions={permissions}
            userProfile={userProfile}
            editMode={editMode}
            areDictsLoaded={areDictsLoaded}
          />
        </Box>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
});

export default connect(null, mapDispatchToProps)(Profile);
